import apiService from "../common/commonApi";

export const updatRequestService = {};

updatRequestService.update = async (param) => {
    return apiService.Put("updateRequest", param);
};
